import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, ViewChild, Directive, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { saveAs } from 'file-saver';
import { finalize, take } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/progress-spinner';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { HttpEventType } from '@angular/common/http';
import * as i1$2 from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

class XpoDownloadButtonIcon {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
    }
    update() {
        this.changeDetectorRef.markForCheck();
    }
}
XpoDownloadButtonIcon.ɵfac = function XpoDownloadButtonIcon_Factory(t) { return new (t || XpoDownloadButtonIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDownloadButtonIcon.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDownloadButtonIcon, selectors: [["xpo-download-button-icon"]], hostAttrs: [1, "xpo-DownloadButtonIcon"], decls: 2, vars: 0, consts: [["mat-icon-button", ""], ["iconName", "download"]], template: function XpoDownloadButtonIcon_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵelement(1, "xpo-icon", 1);
        i0.ɵɵelementEnd();
    } }, directives: [i1.MatButton, i2.XpoIcon], styles: [".xpo-DownloadButtonIcon[_nghost-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:auto;width:auto}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDownloadButtonIcon, [{
        type: Component,
        args: [{
                selector: 'xpo-download-button-icon',
                templateUrl: './download-button-icon.component.html',
                styleUrls: ['./download-button-icon.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-DownloadButtonIcon' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, null); })();

const _c0 = ["textContent"];
function XpoDownloadButton_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function XpoDownloadButton_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.download(); });
    i0.ɵɵelementStart(1, "mat-icon", 4);
    i0.ɵɵtext(2, "keyboard_tab");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r0.color)("disabled", ctx_r0.loading);
} }
function XpoDownloadButton_button_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", null, 8);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
} }
function XpoDownloadButton_button_1_mat_spinner_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 9);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 24);
} }
function XpoDownloadButton_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function XpoDownloadButton_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.download(); });
    i0.ɵɵtemplate(1, XpoDownloadButton_button_1_span_1_Template, 3, 0, "span", 6);
    i0.ɵɵtemplate(2, XpoDownloadButton_button_1_mat_spinner_2_Template, 1, 1, "mat-spinner", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r1.color)("disabled", ctx_r1.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
} }
function XpoDownloadButton_ng_template_2_mat_spinner_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 11);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 30);
} }
function XpoDownloadButton_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, XpoDownloadButton_ng_template_2_mat_spinner_0_Template, 1, 1, "mat-spinner", 10);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r3.hasContent);
} }
const _c1 = ["*"];
class XpoDownloadButton {
    constructor(changeDetection) {
        this.changeDetection = changeDetection;
        this.loading = false;
        this.hasContent = true;
        this.color = 'primary';
        console.warn('\'xpo-DownloadButton\' component is deprecated; use directive \'[xpoDownloadButton]\' instead.');
    }
    ngAfterViewInit() {
        this.hasContent = !!this.textContent.nativeElement.childNodes.length;
        this.changeDetection.detectChanges();
    }
    download() {
        const dataSource = this.buildDataSource();
        if (!dataSource) {
            return;
        }
        this.loading = true;
        dataSource
            .pipe(finalize(() => {
            this.loading = false;
            this.changeDetection.markForCheck();
        }), take(1))
            .subscribe((data) => {
            saveAs(data, this.fileName || data.name);
        }, (error) => {
            console.error(error);
        });
    }
    buildDataSource() {
        if (this.dataSource && this.handleExport) {
            throw new Error('XpoDownloadButton: dataSource and handleExport should not be both provided');
        }
        let currentDataSource = this.dataSource;
        if (!currentDataSource && this.handleExport) {
            currentDataSource = this.handleExport();
        }
        return currentDataSource;
    }
}
XpoDownloadButton.ɵfac = function XpoDownloadButton_Factory(t) { return new (t || XpoDownloadButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoDownloadButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoDownloadButton, selectors: [["xpo-download-button"]], viewQuery: function XpoDownloadButton_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textContent = _t.first);
    } }, hostAttrs: [1, "xpo-DownloadButton"], inputs: { dataSource: "dataSource", handleExport: "handleExport", fileName: "fileName", color: "color" }, ngContentSelectors: _c1, decls: 4, vars: 3, consts: [["mat-icon-button", "", 3, "color", "disabled", "click", 4, "ngIf", "ngIfElse"], ["mat-button", "", 3, "color", "disabled", "click", 4, "ngIf"], ["spinner", ""], ["mat-icon-button", "", 3, "color", "disabled", "click"], [1, "xpo-DownloadButton-icon"], ["mat-button", "", 3, "color", "disabled", "click"], [4, "ngIf"], [3, "diameter", 4, "ngIf"], ["textContent", ""], [3, "diameter"], ["class", "xpo-DownloadButton-spinner", 3, "diameter", 4, "ngIf"], [1, "xpo-DownloadButton-spinner", 3, "diameter"]], template: function XpoDownloadButton_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, XpoDownloadButton_button_0_Template, 3, 2, "button", 0);
        i0.ɵɵtemplate(1, XpoDownloadButton_button_1_Template, 3, 4, "button", 1);
        i0.ɵɵtemplate(2, XpoDownloadButton_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(3);
        i0.ɵɵproperty("ngIf", !ctx.hasContent && !ctx.loading)("ngIfElse", _r2);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasContent);
    } }, directives: [i1$1.NgIf, i1.MatButton, i3.MatIcon, i4.MatSpinner], styles: [".xpo-DownloadButton-icon{font-size:1.5rem;transform:rotate(90deg)}.xpo-DownloadButton-spinner{margin:13px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDownloadButton, [{
        type: Component,
        args: [{
                selector: 'xpo-download-button',
                templateUrl: './download-button.component.html',
                styleUrls: ['./download-button.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-DownloadButton',
                },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { dataSource: [{
            type: Input
        }], handleExport: [{
            type: Input
        }], fileName: [{
            type: Input
        }], color: [{
            type: Input
        }], textContent: [{
            type: ViewChild,
            args: ['textContent']
        }] }); })();

const NO_FILE_CONTENT_MESSAGE = 'No Content in File';
// TODO: Rename this to XpoDownloadButton when deprecated download button is removed
class XpoDownloadButtonDirective {
    constructor(el, viewContainerRef, componentFactoryResolver, renderer, zone, xpoSnackBar) {
        this.el = el;
        this.viewContainerRef = viewContainerRef;
        this.componentFactoryResolver = componentFactoryResolver;
        this.renderer = renderer;
        this.zone = zone;
        this.xpoSnackBar = xpoSnackBar;
        this.displayDefaultIcon = false;
    }
    get replaceContentWithLoader() {
        return this.replaceContentValue;
    }
    set replaceContentWithLoader(value) {
        this.replaceContentValue = coerceBooleanProperty(value);
    }
    handleClick() {
        this.download();
    }
    ngAfterViewInit() {
        this.displayDefaultIcon =
            // display if we don't have a direct text descendant
            !this.el.nativeElement.textContent.length &&
                // and if our first child is without content
                this.el.nativeElement.children.length &&
                !this.el.nativeElement.children[0].innerHTML.length &&
                // and if the user hasn't explicitly informed us how to handle provided content
                !this.replaceContentWithLoader;
        // Avoid ExpressionChangedAfterItHasBeenCheckedError
        this.zone.onStable.pipe(take(1)).subscribe(() => this.showIcon());
    }
    download() {
        if (!this.handleDownload) {
            console.error('XpoDownloadButtonDirective: you must provide handleDownload input value in order to download.');
            return;
        }
        const fileObservable = this.handleDownload();
        if (!fileObservable) {
            console.warn('XpoDownloadButtonDirective: no result was provided by handleDownload. Download will not be perfomed.');
            return;
        }
        this.showLoader();
        this.hideIcon();
        fileObservable
            .pipe(finalize(() => {
            this.hideLoader();
            this.showIcon();
        }), take(1))
            .subscribe((data) => {
            const isDataHttpResponse = data.type === HttpEventType.Response;
            const dataBlob = isDataHttpResponse ? data.body : data;
            if (!dataBlob) {
                this.xpoSnackBar.error(NO_FILE_CONTENT_MESSAGE);
                return;
            }
            const fileName = (isDataHttpResponse ? this.getFilenameFromHeaders(data) : '') || data.filename || data.name;
            saveAs(dataBlob, this.fileName || fileName);
        }, (error) => {
            console.error(error);
        });
    }
    showLoader() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MatSpinner);
        const matSpinner = this.viewContainerRef.createComponent(componentFactory);
        matSpinner.instance.diameter = 20;
        this.progressElement = matSpinner.injector.get(MatSpinner)._elementRef.nativeElement;
        this.renderer.appendChild(this.el.nativeElement, this.progressElement);
        if (this.replaceContentWithLoader) {
            this.displayStyleBeforeHide = this.el.nativeElement.firstChild.style.display;
            this.renderer.setStyle(this.el.nativeElement.firstChild, 'display', 'none');
        }
        else if (!this.displayDefaultIcon) {
            this.renderer.setStyle(this.progressElement, 'margin-left', '4px');
        }
        this.viewContainerRef.element.nativeElement.disabled = true;
    }
    hideLoader() {
        if (this.replaceContentWithLoader) {
            const displayStyleValue = this.displayStyleBeforeHide ? this.displayStyleBeforeHide : 'inline';
            this.renderer.setStyle(this.el.nativeElement.firstChild, 'display', displayStyleValue);
        }
        this.viewContainerRef.element.nativeElement.disabled = false;
        this.renderer.removeChild(this.el.nativeElement, this.progressElement);
    }
    showIcon() {
        if (!this.displayDefaultIcon) {
            return;
        }
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(XpoDownloadButtonIcon);
        this.iconElement = this.viewContainerRef.createComponent(componentFactory);
        this.el.nativeElement.appendChild(this.iconElement.location.nativeElement);
        this.iconElement.instance.update();
    }
    hideIcon() {
        if (!this.displayDefaultIcon) {
            return;
        }
        this.renderer.removeChild(this.el.nativeElement, this.iconElement.location.nativeElement);
    }
    getFilenameFromHeaders(httpResponse) {
        const contentDispositionSegments = httpResponse.headers.get('content-disposition').split(';');
        const fileNameSegment = contentDispositionSegments.find((cd) => cd.includes('filename='));
        return fileNameSegment ? fileNameSegment.split('filename=')[1].trim().replace(/"/g, '') : '';
    }
}
XpoDownloadButtonDirective.ɵfac = function XpoDownloadButtonDirective_Factory(t) { return new (t || XpoDownloadButtonDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1$2.XpoSnackBar)); };
XpoDownloadButtonDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoDownloadButtonDirective, selectors: [["button", "xpoDownloadButton", ""]], hostAttrs: [1, "xpo-DownloadButton"], hostBindings: function XpoDownloadButtonDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function XpoDownloadButtonDirective_click_HostBindingHandler() { return ctx.handleClick(); });
    } }, inputs: { handleDownload: "handleDownload", fileName: "fileName", replaceContentWithLoader: "replaceContentWithLoader" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDownloadButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'button[xpoDownloadButton]',
                host: { class: 'xpo-DownloadButton' },
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }, { type: i0.Renderer2 }, { type: i0.NgZone }, { type: i1$2.XpoSnackBar }]; }, { handleDownload: [{
            type: Input
        }], fileName: [{
            type: Input
        }], replaceContentWithLoader: [{
            type: Input
        }], handleClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class XpoDownloadButtonModule {
}
XpoDownloadButtonModule.ɵfac = function XpoDownloadButtonModule_Factory(t) { return new (t || XpoDownloadButtonModule)(); };
XpoDownloadButtonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoDownloadButtonModule });
XpoDownloadButtonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            MatButtonModule,
            MatProgressSpinnerModule,
            MatTooltipModule,
            MatProgressSpinnerModule,
            XpoIconModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoDownloadButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatButtonModule,
                    MatProgressSpinnerModule,
                    MatTooltipModule,
                    MatProgressSpinnerModule,
                    XpoIconModule,
                ],
                exports: [XpoDownloadButton, XpoDownloadButtonDirective],
                declarations: [XpoDownloadButton, XpoDownloadButtonDirective, XpoDownloadButtonIcon],
                entryComponents: [XpoDownloadButtonIcon, MatSpinner],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoDownloadButtonModule, { declarations: [XpoDownloadButton, XpoDownloadButtonDirective, XpoDownloadButtonIcon], imports: [CommonModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        XpoIconModule], exports: [XpoDownloadButton, XpoDownloadButtonDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoDownloadButton, XpoDownloadButtonDirective, XpoDownloadButtonIcon, XpoDownloadButtonModule };
